/**
 * PresentationViewContext
 *
 * Signals when a mobile exercise-detail / 2.5D presentation view is open.
 * Used to hide the MobileBottomNav so it can never overlap the presentation
 * control dock — even when the detail opens via component state (a Sheet)
 * rather than a route change.
 */
import React, { createContext, useContext, useState, useCallback } from 'react';

const PresentationViewContext = createContext({
  isPresentationOpen: false,
  enterPresentation: () => {},
  exitPresentation: () => {},
});

export function PresentationViewProvider({ children }) {
  const [count, setCount] = useState(0);

  const enterPresentation = useCallback(() => setCount((c) => c + 1), []);
  const exitPresentation = useCallback(() => setCount((c) => Math.max(0, c - 1)), []);

  return (
    <PresentationViewContext.Provider
      value={{ isPresentationOpen: count > 0, enterPresentation, exitPresentation }}
    >
      {children}
    </PresentationViewContext.Provider>
  );
}

export function usePresentationView() {
  return useContext(PresentationViewContext);
}

export default PresentationViewContext;
